import { lazy } from 'react';

export const AsyncFaqPageContainer = lazy(() => import(
  /* webpackChunkName: 'faq_page' */
  './FaqPageContainer'
));
